<template>
  <div>
    <el-dialog
      :before-close="handleClose"
      title="选择人群"
      custom-class="select-people-dialog"
      :visible.sync="selectPeopleDialog"
      width="1050px"
    >
      <div slot="title" class="dialog-title">
        <span>选择人群</span>
      </div>
      <div>
        <el-form :inline="true" :model="crowdParams" label-width="70px" style="display:flex;justify-content:space-between;margin-bottom:20px;align-items: center;">
          <div>
            <el-form-item label="人群名称" style="margin-bottom:0">
              <el-input v-model="crowdParams.name"></el-input>
            </el-form-item>
            <div class="button-group">
              <el-button size="small" class="search" @click="submitForm()">
                <i
                  class="el-icon-search"
                  style="display: inline-block; width: 14px; height: 12px"
                ></i>
                查询
              </el-button>
              <el-button size="small" class="reset" @click="resetForm"
                >重置</el-button
              >
            </div>
          </div>
          <div class="btn_create" @click="toCreatePeople">
            <img :src="btnImg" alt="" style="width:26px;margin-right:-2px" class="">
            <span >去创建人群</span>
          </div>
          <!-- <el-button type="primary" @click="toCreatePeople" class="btn_create">去创建人群</el-button> -->
        </el-form>
        <div class="table-box">
          <el-table
            ref="multipleTable"
            tooltip-effect="light"
            :data="crowdTableData"
             :header-cell-style="{ background: '#fafafa','text-align':'left' }"
            :cell-style="{'text-align':'left'}"
            @selection-change="handleSelectionChange"
            style="width: 100%; border: 1px solid #eee"
            stripe
            v-loading="tableLoading"
          >
            <template slot="empty">
              <div style="margin: 20px">
                <img
                  :src="nodata"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    cursor: pointer;
                  "
                />
                <span class="nodata1">暂无数据</span>
              </div>
            </template>
            <el-table-column
              type="selection"
              width="55"
              :selectable="checkboxT"
            ></el-table-column>
            <el-table-column label="人群名称" prop="name"></el-table-column>
            <el-table-column label="人群人数" prop="count"></el-table-column>
            <el-table-column label="人群类型">
              <template slot-scope="scope">
                {{ scope.row.type | showType }}
              </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime"></el-table-column>
          </el-table>
        </div>
        <!-- 分页器 -->
        <div class="block">
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="crowdParams.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="crowdParams.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="crowdTotal"
          ></el-pagination>
        </div>
        <!-- 底部按钮 -->
        <div class="dialog-footer-btn">
          <el-button class="reset" @click="handleClose">取消</el-button>
          <el-button  class="search" @click="handleConfirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMemberCrowd } from "@/api/marketing/memberCrowd";
import { mapState } from "vuex";

export default {
  /*  选择人群弹窗 */
  name: "select-people",
  props: {
    selectPeopleDialog: {
      type: Boolean,
      default: false,
    },
    peopleList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      nodata: require("@/assets/images/nodata.png"),
      btnImg: require("@/assets/images/btn_添加.svg"),
      crowdTableData: [],
      tableLoading: false,
      crowdParams: {
        current: 1,
        size: 10,
        name: "",
      },
      crowdTotal: 0,
      selectList: [],
      addGroup: [], // 当前页勾选的数据
      val : '',
    };
  },
  destroyed(){
    window.removeEventListener('storage')
  },
  mounted() {
    console.log(this.peopleList);
    this.selectList = this.peopleList;
    this.getPeopleData();
    // 监听LocalStorage变化
    window.addEventListener('storage',(e)=>{
      console.log(e);
      if (this.val!=e.newValue) {
        this.getPeopleData();
      }
      this.val = e.newValue;

    })
  },

  methods: {
    // 将回传的列表数据显示为已勾选
    checkboxT(row, index) {
      if (row.count > 0) {
        return 1;
      } else {
        return 0;
      }
    },
    toCreatePeople(){
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/grouping?create=1",
      }); 
      window.open(routeUrl.href, "_blank");
    },
    showPeopleCheck() {
      // return;

      this.$nextTick(() => {
        console.log("this.crowdTableData", this.crowdTableData);
        var selectList = this.selectList;
        console.log("selectList", selectList);
        this.crowdTableData.forEach((row) => {
          // console.log('row', row)
          for (var i = 0; i < selectList.length; i++) {
            if (row.precisionCrowdStrategyId == selectList[i].precisionCrowdStrategyId) {
              this.$refs.multipleTable.toggleRowSelection(row);
              break;
            }
          }
        });
      });
    },

    handleConfirm() {
      this.computedSelectPeople();
      this.$emit("onConfirm", this.selectList);
    },
    // 勾选内容
    handleSelectionChange(list) {
      // 当前列表页勾选的数据

      // this.selectList = list;

      this.addGroup = list;
      // this.computedSelectPeople();
    },

    // 勾选，取消人群计算
    computedSelectPeople() {
      // 当前列表页勾选的数据
      var addGroup = this.addGroup;
      // 当前列表未勾选的数据
      var delGroup = [];
      this.crowdTableData.forEach((item) => {
        var flag = false;
        addGroup.forEach((selectItem) => {
          if (item.precisionCrowdStrategyId == selectItem.precisionCrowdStrategyId) {
            flag = true;
          }
        });
        if (!flag) {
          delGroup.push(item);
        }
      });
      console.log("delGroup", this.delGroup);

      // 添加数据
      var groupDataList = JSON.parse(JSON.stringify(this.selectList));
      addGroup.forEach(function (addItem) {
        var flag = false; // 是否添加该数据
        groupDataList.forEach(function (groupItem) {
          if (addItem.precisionCrowdStrategyId == groupItem.precisionCrowdStrategyId) {
            flag = true;
          }
        });
        if (!flag) {
          groupDataList.push(addItem);
        }
      });
      console.log("添加之后的", groupDataList);

      // 删除重复数据
      groupDataList = groupDataList.filter(function (groupItem) {
        var flag = true;
        delGroup.forEach(function (delItem) {
          if (delItem.precisionCrowdStrategyId == groupItem.precisionCrowdStrategyId) {
            flag = false;
          }
        });
        return flag;
      });

      console.log("groupDataList", groupDataList);
      this.selectList = groupDataList;
    },

    // 查询人群接口
    submitForm() {
      this.getPeopleData();
    },
    // 重置接口
    resetForm() {
      this.crowdParams = {
        current: 1,
        size: 10,
        name: "",
      };
      this.getPeopleData();
    },

    // 获取人群选择列表
    getPeopleData() {
      this.computedSelectPeople();
      this.tableLoading = true;
      getMemberCrowd(this.crowdParams).then((res) => {
        this.tableLoading = false;
        this.crowdTableData = res.data.records;
        this.crowdTotal = +res.data.total;
        this.showPeopleCheck();
      });
    },
    handleSizeChange(val) {
      this.crowdParams.size = val;
      this.getPeopleData();
    },
    handleCurrentChange(val) {
      this.crowdParams.current = val;
      this.getPeopleData();
    },
    handleClose() {
      this.$emit("onCancle");
    },
  },
  filters: {
    showType: function (val) {
      var result = "";
      if (val == "1") {
        result = "自定义分组";
      } else if (val == "2") {
        result = "筛选条件人群包";
      } else if (val == "0") {
        result = "系统分组";
      }else if (val == "8") {
        result = "上传人群";
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__body-wrapper{
  height: 345px;
  overflow-y: auto;
}
// 选择人群弹窗
.select-people-dialog {
  .table-box {
    max-height: 400px;
    overflow: auto;
  }
  .dialog-title {
    span {
      color: #333;
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;
      .el-button {
        font-size: 14px;
      }
    }
  }
  .search-line {
    margin-bottom: 24px;
    .el-input {
      width: 280px;
      margin-right: 20px;
    }
  }
  .button-group {
    display: inline-block;
    .search {
      width: 98px;
      height: 32px;
      color: #fe4d45;
      font-size:14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size:14px;
      border-radius: 3px;
      border: 1px solid #dddddd;
    
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
   
  }
  .dialog-footer-btn {
    text-align: center;
    margin-top: 30px;
    .search {
      width: 98px;
      height: 32px;
      color: #ffffff;
      font-size:14px;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      color: #666666;
      font-size:14px;
      margin: 0px 0px 0 800px;
      border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .btn_create {
    color: #7F85E9;
    float:right;
    width: 98px;
    height: 28px;
    display: flex;
    align-items: center;
    // line-height: 28px;
    font-size: 14px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>